'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styles = {
  container: {
    backgroundColor: '#eee',
    color: '#FF3B30',
    padding: 20,
    fontFamily: 'monospace',
    fontSize: 16
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    color: 'black',
    fontWeight: 700
  }
};

var Error = function (_React$Component) {
  (0, _inherits3.default)(Error, _React$Component);

  function Error() {
    (0, _classCallCheck3.default)(this, Error);
    return (0, _possibleConstructorReturn3.default)(this, (Error.__proto__ || Object.getPrototypeOf(Error)).apply(this, arguments));
  }

  (0, _createClass3.default)(Error, [{
    key: 'renderGraphQL',
    value: function renderGraphQL() {
      return _react2.default.createElement('div', {
        style: styles.container
      }, _react2.default.createElement('div', {
        style: styles.title
      }, 'GraphQL Error:'), this.props.error.graphQLErrors.map(function (error, index) {
        return _react2.default.createElement('div', {
          key: index
        }, error.message);
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.error.graphQLErrors) {
        return this.renderGraphQL();
      }

      return _react2.default.createElement('div', {
        style: styles.container
      }, _react2.default.createElement('div', {
        style: styles.title
      }, 'Error:'), String(this.props.error));
    }
  }]);
  return Error;
}(_react2.default.Component);

Error.propTypes = {
  error: _propTypes2.default.object
};
exports.default = Error;